module.exports = __webpack_public_path__ + "img/esim-white.42e4ed6e.svg";